import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

import { i18nInstance } from './i18n.js';

export interface I18nProviderProps {
  children: ReactNode;
}

/** Provider a ser montado na raiz do app (envolve <App />). */
export function I18nProvider({ children }: I18nProviderProps) {
  return <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>;
}
